const LOCAL_FEATURE_FLAGS_KEY = "wow_local_feature_flags";

export function isLocalFeatureEnabled(featureName: string): boolean {
  try {
    const flags = localStorage.getItem(LOCAL_FEATURE_FLAGS_KEY);
    if (!flags) return false;
    const parsed: unknown = JSON.parse(flags);
    return Array.isArray(parsed) && parsed.includes(featureName);
  } catch {
    return false;
  }
}

export function enableLocalFeature(featureName: string): void {
  try {
    const flags = localStorage.getItem(LOCAL_FEATURE_FLAGS_KEY);
    const parsed: string[] = flags ? (JSON.parse(flags) as string[]) : [];
    if (!parsed.includes(featureName)) {
      parsed.push(featureName);
      localStorage.setItem(LOCAL_FEATURE_FLAGS_KEY, JSON.stringify(parsed));
    }
  } catch {
    localStorage.setItem(LOCAL_FEATURE_FLAGS_KEY, JSON.stringify([featureName]));
  }
}

export function disableLocalFeature(featureName: string): void {
  try {
    const flags = localStorage.getItem(LOCAL_FEATURE_FLAGS_KEY);
    if (!flags) return;
    const parsed = JSON.parse(flags) as string[];
    const filtered = parsed.filter((f) => f !== featureName);
    localStorage.setItem(LOCAL_FEATURE_FLAGS_KEY, JSON.stringify(filtered));
  } catch {
    // ignore
  }
}
